
<script context="module">

import { 
  VmDefaultSettings,
  VmIcon,
  VmMenu,
  VmMenuItem,
  VmMenuRadio,
  VmMenuRadioGroup,
  VmSettings,
  VmSubmenu 
} from '@vime/core';

import { define } from '../lib';
  

define('vm-default-settings', VmDefaultSettings);
define('vm-icon', VmIcon);
define('vm-menu', VmMenu);
define('vm-menu-item', VmMenuItem);
define('vm-menu-radio', VmMenuRadio);
define('vm-menu-radio-group', VmMenuRadioGroup);
define('vm-settings', VmSettings);
define('vm-submenu', VmSubmenu);
  
</script>

<script>
import { createEventDispatcher, onMount } from 'svelte';
import { setProp } from '../lib';

let __ref;
let __mounted = false;

const dispatch = createEventDispatcher();

let className;

export let style;
export { className as class };

export let pin = 'bottomRight';
export let i18n = {};
export let playbackReady = false;
export let playbackRate = 1;
export let playbackRates = [1];
export let isVideoView = false;
export let playbackQuality = undefined;
export let playbackQualities = [];
export let textTracks = [];
export let currentTextTrack = -1;
export let audioTracks = [];
export let currentAudioTrack = -1;
export let isTextTrackVisible = true;

export const ref = () => __ref;
export const getWebComponent = () => __ref;

onMount(() => { 
  

  __mounted = true; 
});

$: if (__mounted) setProp(__ref, 'i18n', i18n);
$: if (__mounted) setProp(__ref, 'playbackRates', playbackRates);
$: if (__mounted) setProp(__ref, 'playbackQualities', playbackQualities);
$: if (__mounted) setProp(__ref, 'textTracks', textTracks);
$: if (__mounted) setProp(__ref, 'audioTracks', audioTracks);

const onEvent = (e) => {
  e.stopPropagation();
  dispatch(e.type, e.detail);
};
</script>

<vm-default-settings 
  class={className}
  style={style}
  pin={pin}
  playback-ready={playbackReady}
  playback-rate={playbackRate}
  is-video-view={isVideoView}
  playback-quality={playbackQuality}
  current-text-track={currentTextTrack}
  current-audio-track={currentAudioTrack}
  is-text-track-visible={isTextTrackVisible}
  
  bind:this={__ref}
>
  <slot></slot>
</vm-default-settings>
  